<template>
  <router-link class="bear-link" :to="link">
    <el-button :type="type" size="small">{{link}}</el-button>
  </router-link>
</template>
<script>
export default {
  name: 'BearLink',
  props: {
    link: {
      type: String,
      default: '/'
    }
  },
  data() {
    return {}
  },
  computed: {
    isCur() {
      return this.$route.fullPath === this.link
    },
    type() {
      return this.isCur ? 'primary' : 'default'
    }
  }
}
</script>
<style lang="scss" scoped>
.bear-link {
  margin-right: 5px;
  text-decoration: none;
}
</style>